import {
    showNotificationAction,
    hideNotificationAction,
    setLastMeetingIdAction,
    setBackendErrorAction,
    setThemeAction,
} from "./reducers";

// Re-export actions for backward compatibility
export const showNotification = showNotificationAction;
export const hideNotification = hideNotificationAction;
export const setLastMeetingId = setLastMeetingIdAction;
export const setBackendError = setBackendErrorAction;
export const setTheme = setThemeAction;

// Keep the enum for any code that might still reference it
export enum Action {
    SHOW_NOTIFICATION = "notification/showNotification",
    HIDE_NOTIFICATION = "notification/hideNotification",
    LAST_MEETING_ID = "lastMeetingId/setLastMeetingId",
    SET_BACKEND_ERROR = "backendError/setBackendError",
    SET_THEME = "theme/setTheme",
}
